module.exports = __webpack_public_path__ + "static/img/Max-Holmes.d6f4e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Max-Holmes.jpg
// module id = Eng7
// module chunks = 0